import { useLocalStorage } from "@mantine/hooks";

const CART_KEY = "cart";

export type CartItemType = {
  id: string;
  quantity: number;
  typeId: string;
  typeValue: string;

  typeName: string;
  discountPrice: number | null;
  actualPrice: number | undefined;
};

export default function useCart() {
  return useLocalStorage<Map<string, CartItemType>>({
    key: CART_KEY,
    defaultValue: new Map(),
    serialize: (value) => {
      /* return value serialized to string */
      return JSON.stringify(Array.from(value.values()));
    },
    deserialize: (localStorageValue) => {
      if (localStorageValue === undefined) return new Map();
      const items: CartItemType[] = JSON.parse(localStorageValue);
      const map = new Map();
      items.reduce((map, item) => {
        const identifier = item.id + item.typeId;
        map.set(identifier, item);

        return map;
      }, map);
      return map;
    },
  });
}
